<template>
  <div class="flex flex-col items-stretch" :class="{'faulty-composite': validation && validation.$error}" @focus.capture="resultsVisible = true">
    <div @click="getPlace()" :class="{inp: styled}">
      <template v-if="value && value.name">
        {{value.name}}
      </template>
      <template v-else>
        <div class="italic text-gray-500">
          {{placeholder}}
        </div>
      </template>
    </div>
  </div>
</template>

<script>

import { MODAL_SHOW } from '../store/mutation-types'
import PlaceSearch from './modals/PlaceSearch.vue'


export default {
  props: {
    value: Object,
    country: [String, Array],
    placeholder: String,
    styled: {
      type: Boolean,
      default: true
    },
    italianOnly: {
      type: Boolean,
      default: false
    },
    validation: Object,
  },
  data() {
    return {
      text: this.value ? this.value.name : '',
      resultsVisible: false,
      results: []
    }
  },
  methods: {
    getPlace() {
      this.$store.commit('modal/' + MODAL_SHOW, {
        component: PlaceSearch,
        props: {
          country: this.country,
          italianOnly: this.italianOnly
        },
        events: {
          confirm: (place) => {
            this.$emit('input', place)
          }
        }
      })
    },
  }
}
</script>
<style>

</style>